module.exports = __webpack_public_path__ + "img/video-gb.005bcdf6.png";